import { type ReactNode } from "react";
import { Tooltip } from "antd";

export function omittedTagsPlaceholder(omittedValues: { label?: ReactNode }[]) {
  return (
    <Tooltip
      title={omittedValues
        .map((v) => v.label)
        .filter(Boolean)
        .join(", ")}
      trigger={["hover", "focus"]}
    >
      <span tabIndex={0}>+ {omittedValues.length} ...</span>
    </Tooltip>
  );
}
